// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__E6E4A","message":"ForgotPassword_message__chyw3"};